module.exports = __webpack_public_path__ + "img/poster.598fe6e8.jpg";